export const BATTERY_HISTORY_LOADING = "battery-history/loading";
export const BATTERY_HISTORY_ERROR = "battery-history/error";
export const BATTERY_HISTORY_FILTERS = "battery-history/filters";
export const BATTERY_HISTORY_LIST = "battery-history/list";



// WEBPACK FOOTER //
// ./src/actions/scooter/battery-history/constants.js